import { makeStyles } from 'tss-react/mui'

interface DotsLoadingStyleParams {
  width?: number | string,
  circleWidth?: number,
  circleHeight?: number,
  circleColor?: string,
}

const useStyles = makeStyles<DotsLoadingStyleParams>()((theme: any, params) => ({
  '@keyframes sk-bouncedelay': {
    '0%, 80%, 100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1.0)',
    },
  },
  spinner: {
    width: params.width ?? 40,
    textAlign: 'center' as const,

    '& $bounce2': {
      animationDelay: '-0.16s',
    },

    '& $bounce1': {
      animationDelay: '-0.32s',
    },

    '& div': {
      borderRadius: '100%',
      display: 'inline-block',
      animationName: '$sk-bouncedelay',
      animationDuration: '1.4s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
      animationFillMode: 'both',
      width: params.circleWidth ?? 10,
      height: params.circleHeight ?? 10,
      backgroundColor: params.circleColor ?? theme.palette.primary.main,
    },
  },
  bounce1: {},
  bounce2: {},
  bounce3: {},
}))

export default useStyles
